import { useMemo } from 'react'

import { DATE_FORMAT } from 'common/constants/dateFormatConstants'
import { useTimezone } from 'common/hooks/useTimezone'
import { DateService } from 'common/services/dateService'
import { useFetchScheduleDayQuery } from 'features/Schedule/api/schedule.api'

export type TemplateCategoryOption = { id: number; name: string }

type TemplateCategories = { options: TemplateCategoryOption[]; isLoading: boolean }

// The dialog's own source: today's /schedule/day carries the site's categories, catid as `code`.
export const useTemplateCategories = (siteId: string): TemplateCategories => {
  const { timeZone } = useTimezone()
  const today = timeZone
    ? DateService.getCurrentTimeInTimezone(timeZone).format(DATE_FORMAT.PATIENT_TRACKER_DATE)
    : ''
  const { data, isLoading } = useFetchScheduleDayQuery(
    { siteId, date: today },
    { skip: !siteId || !today },
  )
  const categories = data?.appointment_categories

  const options = useMemo(
    () => (categories ?? []).map((c) => ({ id: c.code, name: c.name })),
    [categories],
  )

  return { options, isLoading }
}
